import React from 'react'
import "./advancedhair.css"
const advancedhair = () => {
  return (
    <div>
    
        <div className='advancedhair_ first_content'>
          <div>

          </div>
        
        </div>
    </div>
  )
}

export default advancedhair
